export class SearchFacet {
  constructor(
    key,
    title,
    values,
  ) {
    this.key = key;
    this.title = title;
    /** @type {[SearchFacetsValues]}*/
    this.values = values;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new SearchFacet(
        input.key,
        getTitle(input.key),
        SearchFacetsValues.fromApiArray(input.values),
      )
    }

    return new SearchFacet();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => SearchFacet.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [SearchFacet.fromApiObject(input)];
    }

    return [];
  }
}

export class SearchFacetsValues {
  constructor(
    count,
    filter,
    value,
    checked
  ) {
    this.count = count;
    this.filter = filter;
    this.value = value;
    this.checked = checked;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new SearchFacetsValues(
        input.count,
        input.filter,
        input.value,
        input.checked
      )
    }

    return new SearchFacetsValues();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => SearchFacetsValues.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [SearchFacetsValues.fromApiObject(input)];
    }

    return [];
  }
}

function getTitle(title) {
  let result = title;
  try {
    result = $.i18n("searchProduct_" + title);
  } catch (error) {
    result = "";
  }
  return result
}
